const defaultMessages = require('../../messages.json')

module.exports = Object.assign({}, defaultMessages, {
  'nav.export.cases': 'Export authorisations'
})
